import React, { Component } from 'react'

import { connect } from 'react-redux'
import Loading from './Loading'

class LoadingOverlay extends Component {
  render() {
    return <Loading open={this.props.loading} />
  }
}

const mapStateToProps = (state) => ({
  loading: state.screen.loading,
})

export default connect(mapStateToProps, null)(LoadingOverlay)
